import styled from "styled-components";

export const TitleStyled = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin: 15px 0;
`;
